import { render } from "./allcustomers.vue?vue&type=template&id=36c29aae"
import script from "./allcustomers.vue?vue&type=script&lang=js"
export * from "./allcustomers.vue?vue&type=script&lang=js"

import "./allcustomers.vue?vue&type=style&index=0&id=36c29aae&lang=css"
import "./allcustomers.vue?vue&type=style&index=1&id=36c29aae&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__